/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontHead_seller$ref = any;
type StorefrontHead_user$ref = any;
type StorefrontHead_viewer$ref = any;
type StorefrontHome_products$ref = any;
type StorefrontHome_seller$ref = any;
type StorefrontHome_user$ref = any;
type StorefrontHome_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontLayout_viewer$ref: FragmentReference;
export type StorefrontLayout_viewer = {|
  +user?: ?{|
    +$fragmentRefs: StorefrontHead_user$ref & StorefrontHome_user$ref
  |},
  +seller: ?{|
    +$fragmentRefs: StorefrontHead_seller$ref & StorefrontHome_seller$ref
  |},
  +products: ?{|
    +$fragmentRefs: StorefrontHome_products$ref
  |},
  +$fragmentRefs: StorefrontHead_viewer$ref & StorefrontHome_viewer$ref,
  +$refType: StorefrontLayout_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "sellerId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "urlLabel",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "sellerId",
          "variableName": "sellerId",
          "type": "String!"
        }
      ],
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "StorefrontHead_seller",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "StorefrontHome_seller",
          "args": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "products",
      "name": "dealerStorefront",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "dealer",
          "variableName": "urlLabel",
          "type": "String"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 12,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "storefrontSearch",
          "value": "1",
          "type": "String"
        }
      ],
      "concreteType": "DealerStorefrontQueryConnection",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "StorefrontHome_products",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontHead_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontHome_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "StorefrontHead_user",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "StorefrontHome_user",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '56ec795f26bd7fc42c4a971d1272421d';
module.exports = node;
